import gql from 'graphql-tag'

export const REQUEST_USERNAME = gql`
    query requestUsername($email: String!) {
        requestUsername(email: $email)
    }
`
